import {URL_WEB_SERVICE_LOCAL_STORAGE} from 'constants/general'

export const GET_CONFIG = `${URL_WEB_SERVICE_LOCAL_STORAGE}obtenerConfiguracion`

export const REGISTER_REQUEST = `${URL_WEB_SERVICE_LOCAL_STORAGE}registraSolicitud`

export const GET_DEPARTMENTS = `${URL_WEB_SERVICE_LOCAL_STORAGE}getDepartamentos`;

export const GET_ENTITIES = `${URL_WEB_SERVICE_LOCAL_STORAGE}getEntidades`;

export const GET_MODALITIES = `${URL_WEB_SERVICE_LOCAL_STORAGE}getModalidades`;

export const GET_OPERATORS = `${URL_WEB_SERVICE_LOCAL_STORAGE}getOperadores`;

export const GET_DOCUMENT_TYPES = `${URL_WEB_SERVICE_LOCAL_STORAGE}getTipoDocumentos`;

export const GET_PLANS = `${URL_WEB_SERVICE_LOCAL_STORAGE}getPlanes`;

export const GET_PLAN_BY_ID = `${URL_WEB_SERVICE_LOCAL_STORAGE}getPlan`;

export const GET_BANKS_BY_ID = `${URL_WEB_SERVICE_LOCAL_STORAGE}getBancos`;

export const REGISTER_REQUEST_HOME = `${URL_WEB_SERVICE_LOCAL_STORAGE}registraSolicitudHogar`
